import { genId } from '@ocodelib/ex-util';
import type { ProjectFile } from '@repo/project-interface';
import JSZip from 'jszip';
import { filenameToLanguage } from '../util/filenameToLanguage';

/**
 * pjt 파일의 zip 파일 부분을 unzip 하는 함수
 * 각 프로젝트마다 구현이 다르다.
 */
export async function zipToSource(zipFileBlob: Blob): Promise<ProjectFile[]> {
  const ZIP = new JSZip();
  const zipData = await ZIP.loadAsync(zipFileBlob);
  return await extractProjectFiles(zipData);
}

/**
 * 소스 파일들 로드
 */
async function extractProjectFiles(zipData: JSZip): Promise<ProjectFile[]> {
  // src 폴더의 파일들을 ProjectFile로 만든다
  const srcFiles = ((): JSZip.JSZipObject[] => {
    const files = zipData.folder('src')?.files;
    if (!files) return [];
    return Object.values(files);
  })();

  const resultFiles = [] as ProjectFile[];
  for (const file of srcFiles) {
    const { dir } = file;
    if (dir) {
      continue;
    }
    const name = file.name.replace('src/', '');
    // console.log('XXX relativePath=', relativePath, file);
    const result = await file.async('blob');
    const content = await result.text();
    const language = filenameToLanguage(name) ?? '';

    resultFiles.push({
      fileKey: genId('file_', (id) => resultFiles.some((it) => it.fileKey === id)),
      name,
      path: name,
      content,
      language,
    });
  }
  return resultFiles;
}
